module.exports = __webpack_public_path__ + "static/media/01A.4e412564.png";